/**
 * BoardTabPanel — a board embedded as a tab inside the script Editor.
 * Loads the board once, then stays mounted so Script ⇄ Board swaps are instant.
 */
import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { BoardCanvas } from "@/components/BoardCanvas";
import { toast } from "sonner";

export function BoardTabPanel({ boardId, onStatus, onApi }) {
  const [board, setBoard] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get(`/boards/${boardId}`);
        if (alive) setBoard(data.board);
      } catch (e) {
        toast.error(formatApiError(e.response?.data?.detail) || "Couldn't open the board");
      }
    })();
    return () => { alive = false; };
  }, [boardId]);

  if (!board) {
    return (
      <div className="h-full flex items-center justify-center">
        <p className="text-sm text-[var(--ink-muted)]" data-testid={`board-tab-loading-${boardId}`}>Opening board…</p>
      </div>
    );
  }
  return <BoardCanvas board={board} onStatus={onStatus} onApi={onApi} />;
}
